import { Helmet } from 'react-helmet';

import Jumbotron from '../../components/shared/Jumbotron';
import TabBar from '../../components/shared/TabBar';
import TabWater from './T01_water';
import TabPure from './T02_pure';
import TabOneDay from './T04_oneday';
import TabDeepSea from './T05_deepsea';
import TabBreezy from './T06_breezy';
import TabTuo from './T08_tuo';
import TabBarrel from './T09_barrel';
import jumbotron from '../../assets/images/products/jumbotron.jpg';

const tabItems = [
  {
    title: '풀무원샘물',
    link: '/제품안내/풀무원샘물',
  },
  {
    title: '풀무원 퓨어',
    link: '/제품안내/풀무원-퓨어',
  },
  {
    title: '하루귀리',
    link: '/제품안내/하루귀리',
  },
  {
    title: '해양심층수',
    link: '/제품안내/해양심층수',
  },
  {
    title: '브리지톡',
    link: '/제품안내/브리지톡',
  },
  {
    title: '풀무원투오 미니 워터팩',
    link: '/제품안내/풀무원투오-미니-워터팩',
  },
  {
    title: '대용량 먹는샘물',
    link: '/제품안내/대용량-먹는샘물',
  },
];

const Products = () => {
  const tabIndex = tabItems.findIndex(({ link }) => link === decodeURI(window.location.pathname));

  return (
    <div>
      <Helmet>
        <title>풀무원샘물 - 제품안내</title>
        <link
          rel="canonical"
          href="https://www.pulmuonewater.com/%EC%A0%9C%ED%92%88%EC%95%88%EB%82%B4/%ED%92%80%EB%AC%B4%EC%9B%90%EC%83%98%EB%AC%BC"
        />
      </Helmet>
      <Jumbotron title="제품 안내" subtitle="Products" background={jumbotron} />
      <TabBar items={tabItems} activeIndex={tabIndex} />
      {tabIndex === 0 && <TabWater />}
      {tabIndex === 1 && <TabPure />}
      {tabIndex === 2 && <TabOneDay />}
      {tabIndex === 3 && <TabDeepSea />}
      {tabIndex === 4 && <TabBreezy />}
      {tabIndex === 5 && <TabTuo />}
      {tabIndex === 6 && <TabBarrel />}
    </div>
  );
};

export default Products;
